module.exports = __webpack_public_path__ + "static/media/siterraBg2.0dd5810e.jpg";